export default "__VITE_ASSET__Cj_knekV__"